export const LOCAL_STORAGE = {
  ACCESS_TOKEN: "accessToken",
  SESSION_ID: "sessionId",
  TOKEN: "token",
  LANGUAGE: "language",
  USER_ID: "userId",
  JUST_LOGGED_IN: "justLoggedIn",
  USE_IMPORT_COMPONENT: "useImportComponent",
  USE_PREVIEW: "usePreview",
  USE_VEX: "useVex",
  REDIRECT_AFTER_LOGIN: "redirectAfterLogin",
  SYNCED_ALL_DATA: "syncedAllData",
  LAST_RECONCILE_AT: "lastReconcileAt",
  PERMISSIONS: "permissions",
  IS_SKIP_CLARITY_PROGRESS: "isSkipClarityProgress",
  /** Set while auto-update runs; cleared when summary is shown or acknowledged. */
  AWAITING_UPDATE_SUMMARY: "awaitingUpdateSummary",
};

export const COOKIES = {
  LOGIN_STATUS: "loginStatus",
}

export const LOGGED_IN_STATUS = 'loggedin';

export const CLARITY_STATUS_OPTIONS = [
  { value: "ON_ANALYSIS", label: "Analyzing" },
  { value: "USAGE_TYPE_REVIEW", label: "Usage type review" },
  { value: "USAGE_TYPE_CHECK", label: "Usage type check" },
  { value: "USAGE_TYPE_INPUT", label: "Usage type input" },
  { value: "ON_REVIEW", label: "Review" },
  { value: "STANDBY_FOLLOWUP", label: "Follow-up" },
  { value: "FOLLOWUP_CHECK", label: "Check follow-up" },
  { value: "DONE", label: "Ready" },
  { value: "REVERIFICATION", label: "Re-verification" },
  { value: "ERROR", label: "Error" },
];

export const FOSSID_STATUS_OPTIONS = [
  { value: "ON_ANALYSIS", label: "Analyzing" },
  { value: "ANALYSIS_CHECK", label: "Analysis Check" },
  { value: "REQUEST", label: "Load Identifications" },
  { value: "USAGE_TYPE_CHECK", label: "Usage type check" },
  { value: "USAGE_TYPE_INPUT", label: "Usage type input" },
  { value: "ON_REVIEW", label: "Review" },
  { value: "STANDBY_FOLLOWUP", label: "Follow-up" },
  { value: "FOLLOWUP_CHECK", label: "Check follow-up" },
  { value: "DONE", label: "Ready" },
  { value: "REVERIFICATION", label: "Re-verification" },
  { value: "ERROR", label: "Error" },
];

export const SBOM_STATUS_OPTIONS = [
  { value: "ON_REVIEW", label: "Review" },
  { value: "DONE", label: "Ready" },
  { value: "REVERIFICATION", label: "Re-verification" },
  { value: "ERROR", label: "Error" },
];

export const IMPORTANT_LEVEL_AND_SEVERITY = Object.freeze({
  HIGHEST_AND_CRITICAL: "#8B0000",
  HIGHEST_AND_HIGH: "#FF0000",
  HIGHEST_AND_MEDIUM: "#4682B4",
  HIGHEST_AND_LOW: "#FFA500",
  HIGH_AND_CRITICAL: "#FF0000",
  HIGH_AND_HIGH: "#FF0000",
  HIGH_AND_MEDIUM: "#4682B4",
  HIGH_AND_LOW: "#FFA500",
  MEDIUM_AND_CRITICAL: "#4682B4",
  MEDIUM_AND_HIGH: "#4682B4",
  MEDIUM_AND_MEDIUM: "#4682B4",
  MEDIUM_AND_LOW: "#FFA500",
  LOW_AND_CRITICAL: "#FFA500",
  LOW_AND_HIGH: "#FFA500",
  LOW_AND_MEDIUM: "#FFA500",
  LOW_AND_LOW: "#FFA500",
});

export const VULNERABILITY_CODE_COLOR = Object.freeze({
  1: "#CC1010",
  2: "#E45B5B",
  3: "#355DFF",
  4: "#FFA84C",
});

export const ERROR_API = Object.freeze({
  unauthorized: "error-api.unauthorized",
  forbidden: "error-api.forbidden",
  serverError: "error-api.server-error",
  hostServiceUnreachable: "error-api.host-service-unreachable",
  notfound: "error-api.not-found",
  methodNotAllow: "error-api.method-not-allowed",
  badRequest: "error-api.bad-request",
  ERROR_TIMEOUT: "error-api.timeout",
});

export const ERROR_CODE = Object.freeze({
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  METHOD_NOT_ALLOWED: 405,
  INTERNAL_SERVER_ERROR: 500,
  BAD_REQUEST: 400,
  GATEWAY_TIMEOUT: 504,
  CONFLICT: 409,
});

export const VERIFICATION_TYPE = Object.freeze({
  CLARITY: "CLARITY",
  FOSSID: "FOSSID",
  SBOM: "SBOM",
  CLARITYAIR: "CLARITYAIR",
});

export const TOAST = {
  success: "Success",
  error: "Error",
  warn: "Warning",
  info: "Information",
};

export const SCAN_TYPE = Object.freeze({
  SOURCE_CODE: "S",
  BINARY: "B",
});

export const PROGRESS_CLARITY_STATUS = Object.freeze({
  ANALYSIS: "ON_ANALYSIS",
  VERIFICATION: "ON_VERIFICATION",
  REVIEW: "ON_REVIEW",
  REVERIFICATION: "REVERIFICATION",
  FULFILLMENT: "STANDBY_FOLLOWUP",
  CHECK_FULFILLMENT: "FOLLOWUP_CHECK",
  DONE: "DONE",
});

export const PROGRESS_FOSSID_STATUS = Object.freeze({
  ANALYSIS: "ON_ANALYSIS",
  ANALYSIS_CHECK: "ANALYSIS_CHECK",
  REQUEST: "REQUEST",
  VERIFICATION: "ON_VERIFICATION",
  REVIEW: "ON_REVIEW",
  REVERIFICATION: "REVERIFICATION",
  FULFILLMENT: "STANDBY_FOLLOWUP",
  CHECK_FULFILLMENT: "FOLLOWUP_CHECK",
  DONE: "DONE",
  REQUEST: "REQUEST",
});

export const PROGRESS_SBOM_STATUS = Object.freeze({
  REVIEW: "ON_REVIEW",
  REVERIFICATION: "REVERIFICATION",
  DONE: "DONE",
});

export const PROGRESS_NOTICE_INFORMATION_STATUS = {
  REQUEST: "REQUEST",
  WRITE: "ON_WRITE",
  REVIEW: "ON_REVIEW",
  DONE: "DONE",
};

// Notice Information Custom Option Constants
export const NOTICE_CUSTOM_VALUE = "Custom";
export const NOTICE_CUSTOM_URL_OPTION = Object.freeze({
  name: "Custom",
  original: "Custom URL",
  displayName: "Custom",
});
export const NOTICE_CUSTOM_COPYRIGHT_OPTION = Object.freeze({
  name: "Custom",
  original: "Custom Copyright",
  displayName: "Custom",
});
export const NOTICE_CUSTOM_TEXT_OPTION = Object.freeze({
  name: "Custom",
  original: "Custom Text",
  displayName: "Custom",
});

export const G_LICENSE_USE_APPROVAL_APPROVAL = "APPROVAL";
export const G_LICENSE_USE_APPROVAL_DISAPPROVAL = "DISAPPROVAL";

export const G_ATTRIBUTES = [
  {
    code: "ATTR_01",
    name: "Attribute 1",
    remark: "Right to distribute object/binary code",
  },
  {
    code: "ATTR_02_ALL",
    name: "Attribute 2 - ALL",
    remark: "Source code disclosure/mandatory sharing requirements - ALL",
  },
  {
    code: "ATTR_02_FILE",
    name: "Attribute 2 - FILE",
    remark: "Source code disclosure/mandatory sharing requirements - FILE",
  },
  {
    code: "ATTR_02_LIBRARY",
    name: "Attribute 2 - LIBRARY",
    remark: "Source code disclosure/mandatory sharing requirements - LIBRARY",
  },
  {
    code: "ATTR_02_MODULE",
    name: "Attribute 2 - MODULE",
    remark: "Source code disclosure/mandatory sharing requirements - MODULE",
  },
  {
    code: "ATTR_03",
    name: "Attribute 3",
    remark: "Right to copy and modifiy",
  },
  {
    code: "ATTR_04",
    name: "Attribute 4",
    remark: "Right to reverse engineer",
  },
  {
    code: "ATTR_05",
    name: "Attribute 5",
    remark: "Discriminatory Restrictions Restrictions",
  },
  {
    code: "ATTR_06",
    name: "Attribute 6",
    remark: "Grant of patent license free of charge (without filing a patent lawsuit, license terminates when filed)",
  },
  {
    code: "ATTR_07",
    name: "Attribute 7",
    remark: "Prohibition of protection of technical protection measures, provision of installation information",
  },
  {
    code: "ATTR_08",
    name: "Attribute 8",
    remark: "Notice (including copy of license)",
  },
  {
    code: "ATTR_09",
    name: "Attribute 9",
    remark: "Notice of Changes (including copy of license)",
  },
  {
    code: "ATTR_10",
    name: "Attribute 10",
    remark: "Disclaimer of Warranties and Limitation of Liability",
  },
  {
    code: "ATTR_11",
    name: "Attribute 11",
    remark: "Prohibition on use of distributors, authors, or specific trademarks in advertising/promotion",
  },
  {
    code: "ATTR_12",
    name: "Attribute 12",
    remark: "Same terms as the original code",
  },
  {
    code: "ATTR_13",
    name: "Attribute 13",
    remark: "Scope of source code disclosure/mandatory sharing (ALL/FILE/LIBRARY/MODULE/MPL)",
  },
];

export const FLAG_OPTIONS = [
  { value: "Y", label: "common.yes" },
  { value: "N", label: "common.no" },
];

export const OBLIGATION_TYPE_OPTIONS = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
];

export const VUlNERABILITY_TYPE_OPTIONS = [
  { value: "S", label: "S" },
  { value: "A", label: "A" },
  { value: "B", label: "B" },
  { value: "C", label: "C" },
  { value: "D", label: "D" },
  { value: "E", label: "E" },
  { value: "F", label: "F" },
  { value: "G", label: "G" },
  { value: "H", label: "H" },
  { value: "I", label: "I" },
  { value: "J", label: "J" },
  { value: "K", label: "K" },
  { value: "L", label: "L" },
  { value: "M", label: "M" },
  { value: "N", label: "N" },
  { value: "O", label: "O" },
];

export const SEVERITY_OPTIONS = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "critical", label: "Critical" },
];

export const QA_STATUS_OPTIONS = [
  { value: "QUESTION", label: "qa.status.QUESTION" },
  { value: "ANSWER", label: "qa.status.ANSWER" },
];

export const LOGIN_CONTEXT = {
  SUPERUSER: "SUPERUSER",
  MANAGER: "MANAGER",
  PRODUCT_CREATOR: "PRODUCT_CREATOR",
  PRODUCT_MANAGER: "PRODUCT_MANAGER",
  PROJECT_MANAGER: "PROJECT_MANAGER",
  DEVELOPER: "DEVELOPER",
  ORTHER_PERMISSION: "ORTHER_PERMISSION",
  LICENSE_POLICY_EDIT: "LICENSE_POLICY_EDIT",
  SBOM_EDIT: "SBOM_EDIT",
  VULNERABILITY_POLICY_EDIT: "VULNERABILITY_POLICY_EDIT",
};

export const CVE_LINK = "https://nvd.nist.gov/vuln/detail";
export const SCAN_SITE_LINK = "https://csc.osbc.co.kr/fossid/";

export const ERROR_MESSAGE = Object.freeze({
  PASSWORD_NOT_CORRECT: "Password is not correct!",
  USER_NOT_FOUND: "User doesn't exist!",
  USER_HAD_EXPIRED: "User had expired!",
  USER_HAD_DISABLED: "User had disabled!",
  THE_ID_OR_PASSWORD_IS_INCORRECT: "The ID or password is incorrect",
  ACCOUNT_TEMPORARILY_LOCKED: "Account temporarily locked due to too many failed attempts. Try again later.",
  TOO_MANY_REQUESTS_FROM_IP: "Too many login attempts from this IP. Try again later.",
});

export const SCAN_TYPE_OPTIONS = [
  { value: "Binary", label: "Binary" },
  { value: "Source Code", label: "Source Code" },
  { value: "SBOM", label: "SBOM" },
]

export const VERIF_TYPE_OPTIONS = [
  { value: "Clarity", label: "Clarity" },
  { value: "FossId", label: "FossId" },
  { value: "SBOM", label: "SBOM" },
]

export const REQUEST_LIST_SCAN_TYPE_OPTIONS = [
  { value: "Binary", label: "Binary" },
  { value: "Source Code", label: "Source Code" },
]

export const REQUEST_LIST_VERIF_TYPE_OPTIONS = [
  { value: "Clarity", label: "Clarity" },
  { value: "FossId", label: "FossId" },
]

export const ACTION_STATUSES = {
  PENDING_COMPLETION: 'PENDING COMPLETION',
  PENDING_APPROVAL: 'PENDING APPROVAL',
};

export const BUTTONS = {
  COMPLETE: 'complete',
  REJECT: 'reject',
  APPROVE: 'approve',
};

export const COLOR_CONFLICT_FLAG = Object.freeze({
  POLICY_CONFLICT: "#8B0000",
  LICENSE_CONFLICT: "orange",
  UNDEFINED_CONFLICT: "#9EA5B3",
  UNDEFINED_OBLIGATION: "#FFFFFF",
});

export const DEFAULT_LICENSE_POLICY = {
  POLICY_NAME: "Basic License Policy",
};

export const CHARACTER_LENGTH = Object.freeze({
  DESCRIPTION: 500,
  COMMENT: 1024,
  REQUEST: 1024,
  TITLE: 255,
  LICENSE_NOTE: 10000,
  LICENSE_TEXT: 100000,
  LICENSE_HEADER: 5000,
  LICENSE_COMMENT: 5000,
  REMARK: 1024,
  CONTENT: 2048
});

export const IMPORT_TYPE = {
  ALL: "ALL",
  DATE_RANGE: "DATE_RANGE",
  PROJECT_CODE: "PROJECT_CODE",
};

export const DATE_TYPE = {
  LAST_7_DAYS: "LAST_7_DAYS",
  THIS_MONTH: "THIS_MONTH",
  CUSTOM: "CUSTOM",
};

export const IMPORT_MODE_LABEL = {
  ALL: "preferences.all-fossid-projects",
  DATE_RANGE: "preferences.date-range",
  PROJECT_CODE: "preferences.fossid-project-code",
};

export const LOADING_OVERLAY_DELAY_MS = 100;
export const LOADING_OVERLAY_MIN_VISIBLE_MS = 250;
